/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Button, Segment } from 'semantic-ui-react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUserIdToken } from '../slices/currentUser/currentUserSlice';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];
//Updates the user's personal info on the server
const exileUserAPI = async (idToken = null, exile = false, permanentremoval) => {
    if (!idToken) {
        console.log("no idToken");
        return null;
    }
    if (!exile) {
        console.log("no exile");
        return null;
    }
    console.log("CALLING SERVER with exileuser")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'exileuser',
            'exile': exile,
            'idToken': idToken,
            'permanentremoval': permanentremoval
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from exileuser call");
    }).catch((error) => { console.log(error); });
};

//Exile user
const exileUser = async (idToken, exile, permanentremoval) => {

    await exileUserAPI(idToken, exile, permanentremoval);

    //TODO - is the equivalent of this needed?       signOutFirebase(globalContext);
}

// eslint-disable-next-line no-empty-pattern
const UserRemovalPage = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const idToken = useSelector(selectCurrentUserIdToken);

    const [removalTermsState, setRemovalTermsState] = useState({ radiovalue: "" });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Remove User"));
    }, []);

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            <h2 style={{ textAlign: "center", color: "#AC3B61" }}>User Removal</h2>
            <br /><br />
            <p style={{ maxWidth: "800px" }}>
                <b>You have not been removed yet.</b> You can be removed temporarily such that your data will be stored securely and not available for any use, but if you return to the FEvIR Platform you can continue to grow your same profile. Or you can be removed completely and permanently and there will be no way to re-use any of your data.
            </p>
            <RadioGroup aria-label="remove yourself from fevir"
                name="removeyourselffromfevir"
                value={removalTermsState.radiovalue}
                onChange={(e) => {
                    setRemovalTermsState(prevState => {
                        return { ...prevState, "radiovalue": e.target.value };
                    });
                }}>
                <FormControlLabel value="temporary"
                    control={<Radio color="primary" />}
                    label={<>I would like to be removed <b>Temporarily</b> from FEvIR</>} />
                <FormControlLabel value="permanent"
                    control={<Radio color="primary" />}
                    label={<>I would like to be removed <b>Permanently</b> from FEvIR</>} />
            </RadioGroup>
            <br /><br />
            <Button className="formButton positive"
                content="Remove myself from FEvIR" compact
                onClick={() => {
                    exileUser(idToken, true, removalTermsState.radiovalue === "permanent");
                    navigate("/");
                }}
                disabled={removalTermsState.radiovalue === ""} />
            <span style={{ marginLeft: "10px" }}></span>
            <Button className="formButton negative" content="Cancel"
                onClick={() => { navigate("/editprofile"); }} compact />
        </Segment>
    </div>;
};

export default UserRemovalPage;